// extracted by mini-css-extract-plugin
export default {"header":"List_header__N7zBs","title":"List_title__1QPRV","description":"List_description__wE02o","columns":"List_columns__9viHs"};